export enum MarketDataFeedFormTypesEnum {
    Info = 1,
    Suffixes = 2,
    ReportMap = 3,
    All = 4,
}
